import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  getMedicationcategory,
  AddCouponcode,
  GetAllPartners,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import InputColor from "react-input-color";
import MultiValueTextInput from "../medication/MultiValueTextInput";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class addCouponCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      textFields: [],
      status: "1",
      commision: "1",

      wt_commision: "",
      medicationcategory: [],
      m_category: "0",
      m_categoryError: null,
      description: "",
      descriptionError: null,
      price: "",
      partnerError: null,
      discountError: null,
      discount_type: 1,
      order_limit: "",
      coupon_code: "",
      usage_limit: "",
      code_type: 1,
      startdate: new Date(),
      enddate: new Date(),
      usage_per_customer: "",
      coupon_codeError: null,
      discount: "",
      quantity: "",
      barcode: "",
      is_flash_coupon: 1,
      is_b2b_coupon: 1,
      coupon_type: null,
      cityError: null,
      city: "1",
      codeDisabled: true,
      background_color: "",
      subtitle: "",
      subtitleError: null,
      coupontitle: "",
      coupontitleError: null,
      _notificationSystem: null,
      cardHidden: true,
      is_featured: "2",
      city_info: [],
      CouponCodeunique: "",
      errormessages: [],
      suppliersData: [],
      supplier: "",
      tiers: "",
      coupon_types: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.isFalshMedicine = this.isFalshMedicine.bind(this);
    this.isb2bCoupon = this.isb2bCoupon.bind(this);
    this.coupon_code_error = React.createRef();
  }

  handleMultiTextField(val) {
    this.setState({ textFields: val });
  }

  isFalshMedicine = (e) => {
    var checked = e.target.checked;
    console.log(checked, "isFalshMedicine");
    if (checked) {
      this.setState({ codeDisabled: "disabled" });
    } else {
      this.setState({ codeDisabled: "" });
    }
    this.setState({ is_flash_coupon: checked });
  };
  isb2bCoupon = (e) => {
    const val = e.target.checked;
    if (val) {
      this.setState({ coupon_types: 1 });
    } else {
      this.setState({ coupon_types: 0 });
    }
  };

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Coupon</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/coupons");
    }, 3000);
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    let compelte = 1;
    let pg_no = 1;
    while (compelte == 1) {
      await getMedicationcategory(obj, pg_no)
        // .then((response) => response.json())
        .then((response) => {
          const mdata = response.data;
          if (mdata.data.length == 0) {
            compelte = 0;
          } else {
            var array1 = this.state.medicationcategory;
            var array2 = array1.concat(mdata.data);
            this.setState({
              medicationcategory: array2,
            });
          }
          // this.category_drop();3
          // console.log(response.data);
        });
      pg_no++;
    }

    GetAllPartners(obj).then((res) => {
      console.log("suppliers data", res.data);
      this.setState({ suppliersData: res.data });
    });
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  onChange_tier = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    this.setState({
      tiers: value,
    });
  };

  onSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;
    if (this.state.coupontitle.length == 0) {
      error = true;
      this.setState({
        coupontitleError: (
          <small className="text-danger">Title is required.</small>
        ),
      });
    } else {
      this.setState({ coupontitleError: null });
    }

    if (this.state.discount.length == 0) {
      error = true;
      this.setState({
        discountError: (
          <small className="text-danger">Discount is required.</small>
        ),
      });
    } else {
      this.setState({ discountError: null });
    }

    if (this.state.is_flash_coupon === false) {
      if (this.state.coupon_code.length == 0) {
        error = true;
        this.setState({
          coupon_codeError: (
            <small className="text-danger">Item Code is required.</small>
          ),
        });
      } else {
        this.setState({ coupon_codeError: null });
      }
      // check whether have selected partner

      if (this.state.supplier == "") {
        error = true;
        this.setState({
          partnerError: (
            <small className="text-danger">Partner is required.</small>
          ),
        });
      } else {
        this.setState({ partnerError: null });
      }
    } else {
      this.setState({ coupon_codeError: null });
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var is_flash_coupon = 1;
      var is_active = 1;
      var CouponCode = "";
      {
        if (this.state.is_flash_coupon) {
          CouponCode = "";
        } else {
          CouponCode = this.state.coupon_code;
        }
      }
      CouponCode = this.state.coupon_code;

      const date = new Date(this.state.enddate);
      var dd = ("0" + date.getDate()).slice(-2);
      var mm = ("0" + (date.getMonth() + 1)).slice(-2);
      var yyyy = date.getFullYear();
      var today = yyyy + "-" + mm + "-" + dd;
      AddCouponcode(
        this.state.coupontitle,
        this.state.subtitle,
        this.state.description,
        this.state.background_color,
        CouponCode,
        this.state.discount,
        this.state.usage_limit,
        this.state.usage_per_customer,
        this.state.startdate,
        this.state.enddate,
        this.state.is_flash_coupon,
        is_active,
        this.state.supplier,
        this.state.discount_type,
        this.state.order_limit,
        this.state.code_type,
        this.state.tiers,
        this.state.textFields,
        this.state.coupon_types,
        obj,
      )
        .then((res) => {
          //   console.log(res.data, "response");
          if (res.data.success === false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.coupon_code_error.current.focus();
              this.setState({
                coupon_codeError: (
                  <small className="text-danger">{message.coupon_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({
              commision: "1",
              m_category: "0",
              description: "",
              coupontitle: "",
              price: "",
              coupon_code: "",
              discount: "",
              city: "0",
              is_featured: "2",
            });
          }
          //   this.props.history.push("/admin/coupons");
        })
        .catch((error) => {
          this.handleNetworkError("bl", error);
          console.log(error, "== error");
        });
    }
  };
  handleDateChange = (date) => {
    this.setState({
      startdate: date,
    });
  };

  handleEndDateChange = (date) => {
    this.setState({
      enddate: date,
    });
  };
  setColor = (colors) => {
    this.setState({
      background_color: colors.hex,
    });
  };
  render() {
    const { textFields } = this.state;
    const medicaioncat = this.state.medicationcategory;
    const city_info = this.state.city_info;
    const CouponCodeunique = this.state.CouponCodeunique;
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <FormGroup>
                      <Checkbox
                        number="49"
                        checked={this.state.is_flash_coupon}
                        onChange={(e) => this.isFalshMedicine(e)}
                        label="Is Flash Coupon?"
                      ></Checkbox>
                    </FormGroup>
                    {this.state.is_flash_coupon == 0 && (
                      <FormGroup>
                        <ControlLabel>Partner</ControlLabel>
                        <select
                          className="react-select primary form-control"
                          name="supplier"
                          value={this.state.supplier}
                          onChange={(event) => {
                            this.setState({ supplier: event.target.value });
                          }}
                        >
                          <option value="0">Select Supplier</option>
                          {this.state.suppliersData.map((cus) => (
                            <option value={cus.id}>{cus.name}</option>
                          ))}
                        </select>
                        {this.state.partnerError}
                      </FormGroup>
                    )}
                    <FormGroup>
                      <ControlLabel>Coupon Code</ControlLabel>
                      <FormControl
                        name="coupon_code"
                        value={this.state.coupon_code}
                        disabled={this.state.codeDisabled}
                        onChange={(event) => {
                          this.setState({ coupon_code: event.target.value });
                          ((this.state.is_flash_coupon === 0) &
                            event.target.value) ===
                          ""
                            ? this.setState({
                                coupon_codeError: (
                                  <small className="text-danger">
                                    CouponCode is required.
                                  </small>
                                ),
                              })
                            : this.setState({ coupon_codeError: null });
                        }}
                        placeholder="Enter CouponCode"
                      />
                      {this.state.coupon_codeError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Coupon Title</ControlLabel>
                      <FormControl
                        name="coupontitle"
                        value={this.state.coupontitle}
                        onChange={(event) => {
                          this.setState({ coupontitle: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                coupontitleError: (
                                  <small className="text-danger">
                                    Coupon Title is required.
                                  </small>
                                ),
                              })
                            : this.setState({ coupontitleError: null });
                        }}
                        placeholder="Enter Coupon Title"
                        type="text"
                      />
                      {this.state.coupontitleError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Subtitle</ControlLabel>
                      <FormControl
                        name="subtitle"
                        value={this.state.subtitle}
                        maxlength="41"
                        onChange={(event) => {
                          this.setState({ subtitle: event.target.value });
                        }}
                        placeholder="Enter Subtitle"
                        type="text"
                      />
                      {this.state.subtitleError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Terms & Conditions </ControlLabel>
                      <textarea
                        name="description"
                        value={this.state.description}
                        onChange={(event) => {
                          this.setState({ description: event.target.value });
                        }}
                        placeholder="Enter Description"
                        className="form-control"
                        rows={2}
                        cols={3}
                      ></textarea>
                    </FormGroup>
                    <FormGroup className="backgroundcolorinput">
                      <ControlLabel>Background Color</ControlLabel>
                      <InputColor
                        initialValue="#5e72e4"
                        onChange={this.setColor}
                        placement="right"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Code Type</ControlLabel>
                      <select
                        className="form-control"
                        name="code_type"
                        onChange={this.onChange}
                      >
                        <option value="1">Barcode</option>
                        <option value="2">QRcode</option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Discount</ControlLabel>
                      <Col md={12}>
                        <Col
                          md={4}
                          className="no-padding"
                          style={{ marginTop: "4px" }}
                        >
                          <select
                            onChange={(event) => {
                              this.setState({
                                discount_type: event.target.value,
                              });
                            }}
                            name="discount_type"
                            value={this.state.discount_type}
                            className="form-control"
                          >
                            <option value="1">Flat rate</option>
                            <option value="2">Percentange</option>
                          </select>
                        </Col>
                        <Col md={8}>
                          <FormControl
                            name="discount"
                            value={this.state.discount}
                            onWheel={(e) => e.target.blur()}
                            onChange={(event) => {
                              this.setState({ discount: event.target.value });
                              event.target.value === ""
                                ? this.setState({
                                    discountError: (
                                      <small className="text-danger">
                                        Discount is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ discountError: null });
                            }}
                            placeholder="Enter Discount"
                            type="number"
                            min="1"
                          />
                          {this.state.discountError}
                        </Col>
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Order Limit</ControlLabel>
                      <FormControl
                        name="order_limit"
                        value={this.state.order_limit}
                        onWheel={(e) => e.target.blur()}
                        onChange={(event) => {
                          this.setState({ order_limit: event.target.value });
                        }}
                        placeholder="Enter Order Limit"
                        type="number"
                        min="1"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Usage Limit</ControlLabel>
                      <FormControl
                        name="usage_limit"
                        onWheel={(e) => e.target.blur()}
                        value={this.state.usage_limit}
                        onChange={(event) => {
                          this.setState({ usage_limit: event.target.value });
                        }}
                        placeholder="Enter Usage Limit"
                        type="number"
                        min="1"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Usage Per Customer</ControlLabel>
                      <FormControl
                        name="usage_per_customer"
                        value={this.state.usage_per_customer}
                        onWheel={(e) => e.target.blur()}
                        onChange={(event) => {
                          this.setState({
                            usage_per_customer: event.target.value,
                          });
                        }}
                        placeholder="Enter Usage per customer"
                        type="number"
                        min="1"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Checkbox
                        number="10"
                        onClick={(e) => this.isb2bCoupon(e)}
                        label="Is b2b Coupon?"
                        value="1"
                      ></Checkbox>
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Tiers</ControlLabel>
                      <select
                        className="form-control"
                        name="tier-select"
                        onChange={this.onChange_tier}
                      >
                        <option value="">select</option>
                        <option value="platinum">Platinum</option>
                        <option value="gold">Gold</option>
                        <option value="silver">Silver</option>
                        <option value="browns">Browns</option>
                      </select>
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Tags</ControlLabel>
                      <MultiValueTextInput
                        textFields={textFields}
                        handleMultiTextField={(val) =>
                          this.handleMultiTextField(val)
                        }
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Start Date</ControlLabel>
                      <Datetime
                        timeFormat={false}
                        dateFormat="YYYY-MM-DD"
                        inputProps={{ placeholder: "Start Date" }}
                        defaultValue={new Date()}
                        closeOnSelect={true}
                        value={this.state.startdate}
                        onChange={this.handleDateChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>End Date</ControlLabel>
                      <Datetime
                        timeFormat={false}
                        dateFormat="YYYY-MM-DD"
                        inputProps={{ placeholder: "End Date" }}
                        defaultValue={new Date()}
                        closeOnSelect={true}
                        value={this.state.enddate}
                        onChange={this.handleEndDateChange}
                      />
                    </FormGroup>
                    {/* 
                    <FormGroup>
                      <ControlLabel>Barcode</ControlLabel>
                      <FormControl
                        name="barcode"
                        value={this.state.barcode}
                        onChange={(event) => {
                          this.setState({ barcode: event.target.value });
                        }}
                        placeholder="Enter Barcode"
                        type="text"
                      />
                    </FormGroup>
                    */}
                    <Button
                      onClick={this.onSubmit.bind(this)}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default addCouponCode;
